import { render, staticRenderFns } from "./AddProgress.modal.vue?vue&type=template&id=2b726be3&"
import script from "./AddProgress.modal.vue?vue&type=script&lang=js&"
export * from "./AddProgress.modal.vue?vue&type=script&lang=js&"
import style0 from "./AddProgress.modal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports